import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e18da8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " hello ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search_input = _resolveComponent("search-input")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_refresher = _resolveComponent("refresher")!
  const _component_search_results = _resolveComponent("search-results")!
  const _component_search_latest_list = _resolveComponent("search-latest-list")!
  const _component_search_popular_list = _resolveComponent("search-popular-list")!
  const _component_search_hot_links = _resolveComponent("search-hot-links")!
  const _component_stock_detail = _resolveComponent("stock-detail")!
  const _component_ag_modal = _resolveComponent("ag-modal")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_search_input, {
            modelValue: _ctx.searchValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchValue) = $event)),
            onSubmit: _ctx.onSubmit
          }, null, 8, ["modelValue", "onSubmit"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        "scroll-y": "",
        onTouchstart: _ctx.onBlur
      }, {
        default: _withCtx(() => [
          _createVNode(_component_refresher, {
            slot: "fixed",
            onRefresh: _ctx.onRefresh
          }, null, 8, ["onRefresh"]),
          _withDirectives(_createVNode(_component_search_results, {
            slot: "fixed",
            list: _ctx.searchedItems,
            onSelect: _ctx.onSelect
          }, null, 8, ["list", "onSelect"]), [
            [_vShow, Boolean(_ctx.searchValue)]
          ]),
          _createVNode(_component_search_latest_list, {
            item: _ctx.selectedItem,
            onSelect: _ctx.onSelect
          }, null, 8, ["item", "onSelect"]),
          _createVNode(_component_search_popular_list, {
            list: _ctx.popularStocks,
            onSelect: _ctx.onSelect
          }, null, 8, ["list", "onSelect"]),
          _createVNode(_component_search_hot_links),
          _hoisted_1,
          _createVNode(_component_ag_modal, {
            "model-value": Boolean(_ctx.storkId),
            mode: "ios",
            "swipe-to-close": "",
            "onUpdate:modelValue": _ctx.onClose
          }, {
            default: _withCtx(() => [
              _createVNode(_component_stock_detail, {
                "stock-id": _ctx.storkId,
                onClose: _ctx.onClose
              }, null, 8, ["stock-id", "onClose"])
            ]),
            _: 1
          }, 8, ["model-value", "onUpdate:modelValue"])
        ]),
        _: 1
      }, 8, ["onTouchstart"])
    ]),
    _: 1
  }))
}